let cachedSessionState: boolean | null = null;
const listeners = new Set<(value: boolean | null) => void>();

export function getCachedSessionState() {
    return cachedSessionState;
}

export function publishSessionState(value: boolean | null) {
    cachedSessionState = value;
    listeners.forEach(listener => listener(value));
}

export function subscribeSessionState(listener: (value: boolean | null) => void) {
    listeners.add(listener);
    return () => {
        listeners.delete(listener);
    };
}

export async function invalidateWebsiteSession() {
    const wasAlreadyInvalid = cachedSessionState === false;
    publishSessionState(false);

    if (wasAlreadyInvalid || typeof window === 'undefined') {
        return;
    }

    try {
        await fetch('/api/sessions', {
            method: 'DELETE',
            cache: 'no-store',
        });
    } catch {
        // Local auth state is already invalidated. Cookie cleanup is best-effort.
    }
}
